import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Assortment } from './components/Assortment';
import { Catalog } from './components/Catalog';
import { Benefits } from './components/Benefits';
import { Retail } from './components/Retail';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';

export function App() {
  return (
    <div className="min-h-screen bg-cream text-tea-900 font-sans">
      <Header />
      <main role="main">
        <Hero />
        <HowItWorks />
        <Catalog />
        <Assortment />
        <Benefits />
        <Retail />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
